import { checkAxiosData, checkIfMobile, getAxiosConfig } from 'fe-common'
import { concatMap, from, filter, tap } from 'rxjs'
import { handleMessages, refreshToken } from '../modules/client/utilities'

Object.fromEntries =
  Object.fromEntries ||
  function(arr) {
    return arr.reduce(function(acc, curr) {
      acc[curr[0]] = curr[1]
      return acc
    }, {})
  }

export function convertGetGamesData(
  { rootState },
  {
    isFeatured = null,
    isTryGame = null,
    wallets = null,
    platforms = null,
    types = null,
    subTypes = null,
    gameName = null,
    typeLabels = null,
    lineLabels = null,
    gameCode = null
  } = {
    isFeatured: null,
    isTryGame: null,
    wallets: null,
    platforms: null,
    types: null,
    subTypes: null,
    gameName: null,
    typeLabels: null,
    lineLabels: null,
    gameCode: null
  }
) {
  const data = {
    isMobile: rootState.isMobile
  }
  if (isFeatured !== null) {
    data.isFeatured = isFeatured
  }
  if (isTryGame) {
    data.isTryGame = isTryGame
  }
  if (wallets && Array.isArray(wallets) && wallets.length > 0) {
    data.wallets = wallets
  }
  if (platforms && Array.isArray(platforms) && platforms.length > 0) {
    data.platforms = platforms
  }
  if (types) {
    if (Array.isArray(types) && types.length > 0) {
      data.types = {
        list: types,
        isInclude: true
      }
    } else if (
      types.hasOwnProperty('list') &&
      types.hasOwnProperty('isInclude')
    ) {
      data.types = types
    }
  }
  if (subTypes) {
    if (Array.isArray(subTypes) && subTypes.length > 0) {
      data.subTypes = {
        list: subTypes,
        isInclude: true
      }
    } else if (
      subTypes.hasOwnProperty('list') &&
      subTypes.hasOwnProperty('isInclude')
    ) {
      data.subTypes = subTypes
    }
  }
  if (gameName && gameName.length >= 2) {
    data.gameName = {
      language: rootState.locale,
      name: gameName
    }
  }
  if (typeLabels && Array.isArray(typeLabels) && typeLabels.length > 0) {
    data.typeLabels = typeLabels
  }
  if (lineLabels && Array.isArray(lineLabels) && lineLabels.length > 0) {
    data.lineLabels = lineLabels
  }
  if (gameCode) {
    data.gameCode = gameCode
  }
  return data
}

export const convertGame = ({
  id,
  multiLanguages,
  gamePlatformName,
  gameType,
  labels,
  tryGame,
  pic,
  param,
  wallet,
  rtpInfo,
  isFavorite = false,
  picUrls = [],
  lastOpenTime
}) => {
  const result = {
    id,
    names: Object.fromEntries(
      multiLanguages.map(multiLanguage => Object.values(multiLanguage))
    ),
    platform: gamePlatformName,
    gameCategory: gameType,
    labels,
    tryPlay: tryGame,
    pic,
    param,
    wallet,
    isFavorite,
    picUrls,
    lastOpenTime
  }
  if (rtpInfo) {
    result.rtp = {
      dynamic: rtpInfo.dynamicRtp,
      official: rtpInfo.officialRtp
    }
  }
  return result
}

export const convertHomeGameMap = data => {
  return {
    ...Object.keys(data || {}).map(platform => convertGame(data[platform]))
  }
}

export const convertTopicGame = ({
  id,
  titleIcon,
  labels,
  multiLanguages,
  redirectUrl,
  gameList
}) => {
  return {
    id,
    titleIcon,
    labels,
    names: Object.fromEntries(
      multiLanguages.map(multiLanguage => Object.values(multiLanguage))
    ),
    moreLink: redirectUrl,
    gameList: (gameList || []).map(convertGame)
  }
}

export default {
  namespaced: true,
  state: () => ({
    // for common gameFilter component
    gamePlatforms: [],
    selectedGameFilterPlatforms: [],
    selectedGameFilterType: null,
    selectedGameFilterPayNums: [],
    showGameFilterType: true,
    showGameFilterPayNum: true,
    gameFilterSearchText: null,
    showGameFilterAdvanced: false,
    games: [],
    featureGames: [],
    gameFilterPayNums: [
      'PAY1-10',
      'PAY15-20',
      'PAY25',
      'PAY30',
      'PAY243',
      'PAYMULTI' // paymulti 和 空值
    ],

    allGamesWithoutSlot: [],

    homePlatforms: [], // bs, zh, demo, st
    homeGameMap: null, // bs, zh, demo, st

    selectedHomePlatform: null, // bs, zh, demo, st,

    homeGames: [], // todo: delete if all cc import
    selectedHomeGame: null, // todo: delete if all cc import

    topicGames: [], // 為求分割，待優化名稱
    selectedTopicGame: null, // yc: recommended-games page
    topicGamesPlatforms: [],
    selectedTopicGamePlatform: null,

    selectedTopicGameLabel: 'recommended_group', // recommended_group, live_group, slot_group (yc only)

    favoriteTopicGames: [], // mc only

    inHouseTopicGames: [], // fd2

    enabledPlatforms: [],

    gameSearchList: [],
    gameSearchText: null,

    embedUrl: null, // for internal open use

    embedHtml: null, // for internal open use

    rtpGameMap: null,
    rtpGames: [],

    selectedRtpGameTypes: [], // RtpFilter
    selectedRtpGamePlatforms: [], // RtpFilter

    selectedRtpGameSort: {},

    gameFavorites: []
  }),
  actions: {
    /**
     * data = {
     *   "isMobile": false,
     *   "isFeatured": false,
     *   "isTryGame": false,
     *   "wallets": [
     *     "SOLID",
     *     "PNG"
     *   ],
     *   "platforms": [
     *     "GH",
     *     "PT"
     *   ],
     *   "types": {
     *     "list": [
     *       "SLOT",
     *       "LIVE",
     *       "SPORT",
     *       "FISHING",
     *       "CHESSCARD",
     *       "LOTTERY",
     *       "ANIMAL"
     *     ],
     *     "isInclude": true
     *   },
     *   "subTypes": {
     *     "list": [
     *       "ARCADE",
     *       "TABLE",
     *       "POKER",
     *       "CHESS",
     *       "OTHER"
     *     ],
     *     "isInclude": true
     *   },
     *   "gameName": {
     *     "language": "zh",
     *     "name": "海洋之心"
     *   },
     *   "typeLabels": [
     *     "HOT",
     *     "NEW",
     *     "JP",
     *     "MATCH",
     *     "NO_BONUS",
     *     "SLOT",
     *     "ARCADE",
     *     "TABLE",
     *     "POKER",
     *     "CHESS",
     *     "BACCARAT",
     *     "BLACKJACK",
     *     "ROULETTE",
     *     "POKER",
     *     "OTHER"
     *   ],
     *   "lineLabels": [
     *     "PAY1-10",
     *     "PAY15-20",
     *     "PAY25",
     *     "PAY30",
     *     "PAY243",
     *     "OTHER"
     *   ],
     *   "gameCode": ""
     * }
     *
     * @param context
     * @param payload
     * @returns {Promise<AxiosResponse<any>>}
     */
    getGames(context, payload) {
      const data = convertGetGamesData(context, payload)
      const config = payload && payload.config ? payload.config : {}
      return this.$axios.$post(
        `/webapi/index/getGameInfo`,
        {
          ...data
        },
        getAxiosConfig(context, config)
      )
    },
    getTopicGames(
      context,
      { labels = [], config = {} } = { labels: [], config: {} }
    ) {
      const { rootState } = context
      return this.$axios.$get(
        `/webapi/index/getTopicGameInfo?isMobile=${rootState.isMobile}${
          labels.length > 0
            ? '&labels=' + encodeURIComponent(labels.join(','))
            : ''
        }`,
        getAxiosConfig(context, config)
      )
    },
    getHomeTopicGames(context) {
      const { dispatch, commit } = context
      return from(
        dispatch('getTopicGames', {
          labels: ['home']
        })
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit(
              'TOPIC_GAMES',
              (data || [])
                .filter(item => item.labels.includes('home'))
                .map(convertTopicGame)
            )
          })
        )
        .toPromise()
    },
    getFavoriteTopicGames(context) {
      const { dispatch, commit } = context
      return from(
        dispatch('getTopicGames', {
          labels: ['home-favorite']
        })
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit(
              'FAVORITE_TOPIC_GAMES',
              (data || [])
                .filter(item => item.labels.includes('home-favorite'))
                .map(convertTopicGame)
            )
          })
        )
        .toPromise()
    },
    getInHouseTopicGames(context, { config = {} } = { config: {} }) {
      const { commit, dispatch } = context
      return from(dispatch('getTopicGames', { labels: ['in-house'], config }))
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('IN_HOUSE_TOPIC_GAMES', (data || []).map(convertTopicGame))
          })
        )
        .toPromise()
    },
    play(context, payload) {
      const { rootState } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/game/getGameUrlInfo`,
                {
                  ...payload,
                  param: {
                    ...payload.param,
                    isMobile: process.client
                      ? checkIfMobile(navigator.userAgent)
                      : rootState.isMobile,
                    lang: rootState.locale,
                    isFromHome: $nuxt.$route.path === '/'
                  }
                },
                getAxiosConfig(context, { timeout: 15 * 1000 })
              )
            )
          )
        )
        .toPromise()
    },
    playTry(context, payload) {
      const { rootState } = context
      return this.$axios.$post(
        `/webapi/index/getGameUrlInfo`,
        {
          ...payload,
          param: {
            ...payload.param,
            tryGame: true,
            isMobile: process.client
              ? checkIfMobile(navigator.userAgent)
              : rootState.isMobile,
            lang: rootState.locale,
            isFromHome: $nuxt.$route.path === '/'
          }
        },
        getAxiosConfig(context, { timeout: 15 * 1000 })
      )
    },
    activityPlay(context, { id, platform }) {
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/game/${platform}/activity/${id}`,
                {},
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    getEnabledPlatforms(context) {
      const { commit } = context
      commit('ENABLED_PLATFORMS', [])
      return from(
        this.$axios.$get(
          `/webapi/index/getEnablePlatformList`,
          getAxiosConfig(context)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('ENABLED_PLATFORMS', data)
          })
        )
        .toPromise()
    },

    /**
     *
     * response single object:
     * {
     *   ...game,
     *   "rtpInfo": {
     *     "officialRtp": "96.6%",
     *     "dynamicRtp": "33.1%"
     *   }
     * }
     *
     * @param context
     * @param type:string 'day' | 'week' | 'month'
     * @param sort:string 'asc' | 'desc'
     * @returns {Promise<AxiosResponse<any>>}
     */
    getRtpGames(
      context,
      { type = 'day', sort = 'desc' } = { type: 'day', sort: 'desc' }
    ) {
      const { rootState, commit } = context

      let queryBy
      switch (type) {
        case 'day':
          queryBy = 'RTP_D'
          break
        case 'week':
          queryBy = 'RTP_W'
          break
        case 'month':
          queryBy = 'RTP_M'
          break
        default:
          queryBy = null
          break
      }

      return from(
        this.$axios.$get(
          `/webapi/index/getRtpGameInfo?isMobile=${rootState.isMobile}${
            queryBy ? '&queryBy=' + queryBy : ''
          }&orderBy=${sort === 'asc' ? 'ASC' : 'DESC'}`,
          getAxiosConfig(context)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('RTP_GAMES', (data || []).map(convertGame))
          })
        )
        .toPromise()
    },
    /**
     *
     * response data:
     * {
     *   "high":[],
     *   "low":[]
     * }
     *
     * @param context
     * @param type:string 'day' | 'week' | 'month'
     * @param limit:number
     * @returns {Promise<AxiosResponse<any>>}
     */
    getRtpGameMap(
      context,
      { type = 'day', limit = 10 } = { type: 'day', limit: 10 }
    ) {
      const { rootState, commit } = context

      let queryBy
      switch (type) {
        case 'day':
          queryBy = 'RTP_D'
          break
        case 'week':
          queryBy = 'RTP_W'
          break
        case 'month':
          queryBy = 'RTP_M'
          break
        default:
          queryBy = null
          break
      }
      return from(
        this.$axios.$get(
          `/webapi/index/getHighAndLowRtpGameInfo?isMobile=${
            rootState.isMobile
          }${queryBy ? '&queryBy=' + queryBy : ''}&limit=${limit}`,
          getAxiosConfig(context)
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            data = JSON.parse(data)
            Object.keys(data).forEach(key => {
              data[key] = data[key].map(convertGame)
            })
            commit('RTP_GAME_MAP', data)
          })
        )
        .toPromise()
    },
    addGameFavorite({ dispatch }, payload) {
      return dispatch('maintainGameFavorite', {
        ...payload,
        maintainType: 'add'
      })
    },
    removeGameFavorite({ dispatch }, payload) {
      return dispatch('maintainGameFavorite', {
        ...payload,
        maintainType: 'remove'
      })
    },
    maintainGameFavorite(context, payload) {
      const { rootState } = context
      const data = { ...payload }
      delete data.maintainType
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$post(
                `/webapi/game/${payload.maintainType}Favorite`,
                {
                  ...data,
                  param: {
                    ...data.param,
                    isMobile: process.client
                      ? checkIfMobile(navigator.userAgent)
                      : rootState.isMobile
                  }
                },
                getAxiosConfig(context)
              )
            )
          )
        )
        .toPromise()
    },
    initGameFavorites({ commit }) {
      commit('GAME_FAVORITES', [])
    },
    getGameFavorites(context, { config = {} } = { config: {} }) {
      const { commit } = context
      return from(refreshToken(context))
        .pipe(
          concatMap(() =>
            from(
              this.$axios.$get(
                `/webapi/game/getFavorites`,
                getAxiosConfig(context, config)
              )
            )
          ),
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => {
            commit('GAME_FAVORITES', (data || []).map(convertGame))
          })
        )
        .toPromise()
    }
  },
  mutations: {
    ALL_GAMES_WITHOUT_SLOT(state, payload) {
      state.allGamesWithoutSlot = payload
    },
    HOME_PLATFORMS(state, payload) {
      state.homePlatforms = payload
    },
    HOME_GAME_MAP(state, payload) {
      state.homeGameMap = payload
    },
    SELECTED_HOME_PLATFORM(state, payload) {
      state.selectedHomePlatform = payload
    },
    // todo: delete if all cc import
    HOME_GAMES(state, payload) {
      state.homeGames = payload
    },
    // todo: delete if all cc import
    SELECTED_HOME_GAME(state, payload) {
      state.selectedHomeGame = payload
    },
    TOPIC_GAMES(state, payload) {
      state.topicGames = payload
    },
    SELECTED_TOPIC_GAME(state, payload) {
      state.selectedTopicGame = payload
    },
    TOPIC_GAMES_PLATFORMS(state, payload) {
      state.topicGamesPlatforms = payload
    },
    SELECTED_TOPIC_GAME_PLATFORM(state, payload) {
      state.selectedTopicGamePlatform = payload
    },
    SELECTED_TOPIC_GAME_LABEL(state, payload) {
      state.selectedTopicGameLabel = payload
    },
    FAVORITE_TOPIC_GAMES(state, payload) {
      state.favoriteTopicGames = payload
    },
    IN_HOUSE_TOPIC_GAMES(state, payload) {
      state.inHouseTopicGames = payload
    },
    ENABLED_PLATFORMS(state, payload) {
      state.enabledPlatforms = payload
    },
    GAME_SEARCH_LIST(state, payload) {
      state.gameSearchList = payload
    },
    GAME_SEARCH_TEXT(state, payload) {
      state.gameSearchText = payload
    },

    EMBED_URL(state, payload) {
      state.embedUrl = payload
    },
    EMBED_HTML(state, payload) {
      state.embedHtml = payload
    },
    RTP_GAME_MAP(state, payload) {
      state.rtpGameMap = payload
    },
    RTP_GAMES(state, payload) {
      state.rtpGames = payload
    },
    SELECTED_RTP_GAME_PLATFORMS(state, payload) {
      state.selectedRtpGamePlatforms = payload
    },
    SELECTED_RTP_GAME_TYPES(state, payload) {
      state.selectedRtpGameTypes = payload
    },
    SELECTED_RTP_GAME_SORT(state, payload) {
      state.selectedRtpGameSort = payload
    },
    GAME_FAVORITES(state, payload) {
      state.gameFavorites = payload
    },
    // for common gameFilter component
    GAME_PLATFORMS(state, payload) {
      state.gamePlatforms = payload
    },
    SELECTED_GAME_FILTER_PLATFORMS(state, payload) {
      state.selectedGameFilterPlatforms = payload
    },
    SELECTED_GAME_FILTER_TYPE(state, payload) {
      state.selectedGameFilterType = payload
    },
    SELECTED_GAME_FILTER_PAY_NUMS(state, payload) {
      state.selectedGameFilterPayNums = payload
    },
    SHOW_GAME_FILTER_TYPE(state, payload) {
      state.showGameFilterType = payload
    },
    SHOW_GAME_FILTER_PAY_NUM(state, payload) {
      state.showGameFilterPayNum = payload
    },
    GAME_FILTER_SEARCH_TEXT(state, payload) {
      state.gameFilterSearchText = payload
    },
    SHOW_GAME_FILTER_ADVANCED(state, payload) {
      state.showGameFilterAdvanced = payload
    },
    GAMES(state, payload) {
      state.games = payload
    },
    FEATURE_GAMES(state, payload) {
      state.featureGames = payload
    },
    GAME_FILTER_PAY_NUMS(state, payload) {
      state.gameFilterPayNums = payload
    }
  },
  getters: {
    allGamesWithoutSlot: state => state.allGamesWithoutSlot,
    homePlatforms: state => state.homePlatforms,
    homeGameMap: state => state.homeGameMap,
    selectedHomePlatform: state => state.selectedHomePlatform,
    homeGames: state => state.homeGames, // todo: delete if all cc import
    selectedHomeGame: state => state.selectedHomeGame, // todo: delete if all cc import
    topicGames: state => state.topicGames,
    selectedTopicGame: state => state.selectedTopicGame,
    topicGamesPlatforms: state => state.topicGamesPlatforms,
    selectedTopicGamePlatform: state => state.selectedTopicGamePlatform,
    selectedTopicGameLabel: state => state.selectedTopicGameLabel,
    favoriteTopicGames: state => state.favoriteTopicGames,
    inHouseTopicGames: state => state.inHouseTopicGames,
    enabledPlatforms: state => state.enabledPlatforms,
    gameSearchList: state => state.gameSearchList,
    gameSearchText: state => state.gameSearchText,

    embedUrl: state => state.embedUrl,
    embedHtml: state => state.embedHtml,
    rtpGameMap: state => state.rtpGameMap,
    rtpGames: state => state.rtpGames,
    selectedRtpGamePlatforms: state => state.selectedRtpGamePlatforms,
    selectedRtpGameTypes: state => state.selectedRtpGameTypes,
    selectedRtpGameSort: state => state.selectedRtpGameSort,

    gameFavorites: state => state.gameFavorites,

    // for common gameFilter component
    gamePlatforms(state) {
      return state.gamePlatforms
    },
    selectedGameFilterPlatforms(state) {
      return state.selectedGameFilterPlatforms
    },
    selectedGameFilterType(state) {
      return state.selectedGameFilterType
    },
    selectedGameFilterPayNums(state) {
      return state.selectedGameFilterPayNums
    },
    showGameFilterType(state) {
      return state.showGameFilterType
    },
    showGameFilterPayNum(state) {
      return state.showGameFilterPayNum
    },
    gameFilterSearchText(state) {
      return state.gameFilterSearchText
    },
    showGameFilterAdvanced(state) {
      return state.showGameFilterAdvanced
    },
    games: state => state.games,
    featureGames(state) {
      return state.featureGames
    },
    gameFilterPayNums(state) {
      return state.gameFilterPayNums
    }
  }
}
